module.exports = __webpack_public_path__ + "img/terroir-grid-1-mobile.3e33ee76.jpg";